// Attention!
// Do not edit directly! The hardcoded values of these tokens are token references
// that get resolved when the .js/d.ts files are being generated from the token JSON files.
const common = {
    fontFamily: 'AudiType, sans-serif',
    textDecoration: 'none',
    letterSpacing: '0px'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_XS = {
    ...common,
    fontWeight: '400',
    fontSize: '40px',
    lineHeight: '60px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_SM = {
    ...common,
    fontWeight: '400',
    fontSize: '40px',
    lineHeight: '60px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_MD = {
    ...common,
    fontWeight: '400',
    fontSize: '48px',
    lineHeight: '68px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_LG = {
    ...common,
    fontWeight: '400',
    fontSize: '60px',
    lineHeight: '84px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_XL = {
    ...common,
    fontWeight: '400',
    fontSize: '72px',
    lineHeight: '100px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP2_XL = {
    ...common,
    fontWeight: '400',
    fontSize: '84px',
    lineHeight: '112px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_XS = {
    ...common,
    fontWeight: '400',
    fontSize: '36px',
    lineHeight: '52px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_SM = {
    ...common,
    fontWeight: '400',
    fontSize: '36px',
    lineHeight: '52px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_MD = {
    ...common,
    fontWeight: '400',
    fontSize: '44px',
    lineHeight: '60px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_LG = {
    ...common,
    fontWeight: '400',
    fontSize: '52px',
    lineHeight: '76px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_XL = {
    ...common,
    fontWeight: '400',
    fontSize: '60px',
    lineHeight: '84px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP2_XL = {
    ...common,
    fontWeight: '400',
    fontSize: '72px',
    lineHeight: '100px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP_XS = {
    ...common,
    fontWeight: '400',
    fontSize: '32px',
    lineHeight: '48px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP_SM = {
    ...common,
    fontWeight: '400',
    fontSize: '32px',
    lineHeight: '48px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP_MD = {
    ...common,
    fontWeight: '400',
    fontSize: '36px',
    lineHeight: '52px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP_LG = {
    ...common,
    fontWeight: '400',
    fontSize: '44px',
    lineHeight: '64px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP_XL = {
    ...common,
    fontWeight: '400',
    fontSize: '52px',
    lineHeight: '76px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP2_XL = {
    ...common,
    fontWeight: '400',
    fontSize: '60px',
    lineHeight: '84px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_XS = {
    ...common,
    fontWeight: '400',
    fontSize: '28px',
    lineHeight: '40px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_SM = {
    ...common,
    fontWeight: '400',
    fontSize: '28px',
    lineHeight: '40px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_MD = {
    ...common,
    fontWeight: '400',
    fontSize: '28px',
    lineHeight: '40px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_LG = {
    ...common,
    fontWeight: '400',
    fontSize: '36px',
    lineHeight: '52px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_XL = {
    ...common,
    fontWeight: '400',
    fontSize: '40px',
    lineHeight: '60px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP2_XL = {
    ...common,
    fontWeight: '400',
    fontSize: '44px',
    lineHeight: '64px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_XS = {
    ...common,
    fontWeight: '700',
    fontSize: '28px',
    lineHeight: '40px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_SM = {
    ...common,
    fontWeight: '700',
    fontSize: '28px',
    lineHeight: '40px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_MD = {
    ...common,
    fontWeight: '700',
    fontSize: '28px',
    lineHeight: '40px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_LG = {
    ...common,
    fontWeight: '700',
    fontSize: '36px',
    lineHeight: '52px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_XL = {
    ...common,
    fontWeight: '700',
    fontSize: '40px',
    lineHeight: '60px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP2_XL = {
    ...common,
    fontWeight: '700',
    fontSize: '44px',
    lineHeight: '64px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_XS = {
    ...common,
    fontWeight: '400',
    fontSize: '24px',
    lineHeight: '36px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_SM = {
    ...common,
    fontWeight: '400',
    fontSize: '24px',
    lineHeight: '36px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_MD = {
    ...common,
    fontWeight: '400',
    fontSize: '24px',
    lineHeight: '36px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_LG = {
    ...common,
    fontWeight: '400',
    fontSize: '28px',
    lineHeight: '40px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_XL = {
    ...common,
    fontWeight: '400',
    fontSize: '32px',
    lineHeight: '44px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP2_XL = {
    ...common,
    fontWeight: '400',
    fontSize: '36px',
    lineHeight: '52px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_XS = {
    ...common,
    fontWeight: '700',
    fontSize: '24px',
    lineHeight: '36px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_SM = {
    ...common,
    fontWeight: '700',
    fontSize: '24px',
    lineHeight: '36px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_MD = {
    ...common,
    fontWeight: '700',
    fontSize: '24px',
    lineHeight: '36px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_LG = {
    ...common,
    fontWeight: '700',
    fontSize: '28px',
    lineHeight: '40px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_XL = {
    ...common,
    fontWeight: '700',
    fontSize: '32px',
    lineHeight: '44px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP2_XL = {
    ...common,
    fontWeight: '700',
    fontSize: '36px',
    lineHeight: '52px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_XS = {
    ...common,
    fontWeight: '400',
    fontSize: '20px',
    lineHeight: '32px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_SM = {
    ...common,
    fontWeight: '400',
    fontSize: '20px',
    lineHeight: '32px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_MD = {
    ...common,
    fontWeight: '400',
    fontSize: '20px',
    lineHeight: '32px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_LG = {
    ...common,
    fontWeight: '400',
    fontSize: '20px',
    lineHeight: '32px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_XL = {
    ...common,
    fontWeight: '400',
    fontSize: '24px',
    lineHeight: '36px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP2_XL = {
    ...common,
    fontWeight: '400',
    fontSize: '24px',
    lineHeight: '36px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_XS = {
    ...common,
    fontWeight: '700',
    fontSize: '20px',
    lineHeight: '32px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_SM = {
    ...common,
    fontWeight: '700',
    fontSize: '20px',
    lineHeight: '32px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_MD = {
    ...common,
    fontWeight: '700',
    fontSize: '20px',
    lineHeight: '32px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_LG = {
    ...common,
    fontWeight: '700',
    fontSize: '20px',
    lineHeight: '32px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_XL = {
    ...common,
    fontWeight: '700',
    fontSize: '24px',
    lineHeight: '36px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP2_XL = {
    ...common,
    fontWeight: '700',
    fontSize: '24px',
    lineHeight: '36px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_XS = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_SM = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_MD = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_LG = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_XL = {
    ...common,
    fontWeight: '400',
    fontSize: '18px',
    lineHeight: '28px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP2_XL = {
    ...common,
    fontWeight: '400',
    fontSize: '20px',
    lineHeight: '32px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_XS = {
    ...common,
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_SM = {
    ...common,
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_MD = {
    ...common,
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_LG = {
    ...common,
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_XL = {
    ...common,
    fontWeight: '700',
    fontSize: '18px',
    lineHeight: '28px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP2_XL = {
    ...common,
    fontWeight: '700',
    fontSize: '20px',
    lineHeight: '32px',
    fontStretch: '130%'
};
export const SYS_TYPOGRAPHY_COPY_ORDER1_NORMAL = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_COPY_ORDER1_BOLD = {
    ...common,
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_COPY_ORDER1_SHORT = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_COPY_ORDER1_SHORT_BOLD = {
    ...common,
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_COPY_ORDER2_NORMAL = {
    ...common,
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '24px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_COPY_ORDER2_BOLD = {
    ...common,
    fontWeight: '700',
    fontSize: '14px',
    lineHeight: '24px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_COPY_ORDER2_SHORT = {
    ...common,
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_COPY_ORDER2_SHORT_BOLD = {
    ...common,
    fontWeight: '700',
    fontSize: '14px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_COPY_ORDER3_NORMAL = {
    ...common,
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_COPY_ORDER3_BOLD = {
    ...common,
    fontWeight: '700',
    fontSize: '12px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_COPY_ORDER3_SHORT = {
    ...common,
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '16px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_COPY_ORDER3_SHORT_BOLD = {
    ...common,
    fontWeight: '700',
    fontSize: '12px',
    lineHeight: '16px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_COPY_ORDER4_NORMAL = {
    ...common,
    fontWeight: '400',
    fontSize: '10px',
    lineHeight: '16px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_COPY_ORDER4_BOLD = {
    ...common,
    fontWeight: '700',
    fontSize: '10px',
    lineHeight: '16px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_COPY_ORDER4_SHORT = {
    ...common,
    fontWeight: '400',
    fontSize: '10px',
    lineHeight: '12px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_COPY_ORDER4_SHORT_BOLD = {
    ...common,
    fontWeight: '700',
    fontSize: '10px',
    lineHeight: '12px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_CAPTION_NORMAL = {
    ...common,
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '16px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LINK_ORDER1_NORMAL = {
    fontFamily: 'AudiType, sans-serif',
    letterSpacing: '0px',
    fontWeight: '400',
    textDecoration: 'underline',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LINK_ORDER1_BOLD = {
    fontFamily: 'AudiType, sans-serif',
    letterSpacing: '0px',
    fontWeight: '700',
    textDecoration: 'underline',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LINK_ORDER1_SHORT = {
    fontFamily: 'AudiType, sans-serif',
    letterSpacing: '0px',
    fontWeight: '400',
    textDecoration: 'underline',
    fontSize: '16px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LINK_ORDER1_SHORT_BOLD = {
    fontFamily: 'AudiType, sans-serif',
    letterSpacing: '0px',
    fontWeight: '700',
    textDecoration: 'underline',
    fontSize: '16px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LINK_ORDER2_NORMAL = {
    fontFamily: 'AudiType, sans-serif',
    letterSpacing: '0px',
    fontWeight: '400',
    textDecoration: 'underline',
    fontSize: '14px',
    lineHeight: '24px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LINK_ORDER2_BOLD = {
    fontFamily: 'AudiType, sans-serif',
    letterSpacing: '0px',
    fontWeight: '700',
    textDecoration: 'underline',
    fontSize: '14px',
    lineHeight: '24px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LINK_ORDER2_SHORT = {
    fontFamily: 'AudiType, sans-serif',
    letterSpacing: '0px',
    fontWeight: '400',
    textDecoration: 'underline',
    fontSize: '14px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LINK_ORDER2_SHORT_BOLD = {
    fontFamily: 'AudiType, sans-serif',
    letterSpacing: '0px',
    fontWeight: '700',
    textDecoration: 'underline',
    fontSize: '14px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LINK_ORDER3_NORMAL = {
    fontFamily: 'AudiType, sans-serif',
    letterSpacing: '0px',
    fontWeight: '400',
    textDecoration: 'underline',
    fontSize: '12px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LINK_ORDER3_BOLD = {
    fontFamily: 'AudiType, sans-serif',
    letterSpacing: '0px',
    fontWeight: '700',
    textDecoration: 'underline',
    fontSize: '12px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LINK_ORDER3_SHORT = {
    fontFamily: 'AudiType, sans-serif',
    letterSpacing: '0px',
    fontWeight: '400',
    textDecoration: 'underline',
    fontSize: '12px',
    lineHeight: '16px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LINK_ORDER3_SHORT_BOLD = {
    fontFamily: 'AudiType, sans-serif',
    letterSpacing: '0px',
    fontWeight: '700',
    textDecoration: 'underline',
    fontSize: '12px',
    lineHeight: '16px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LINK_ORDER4_NORMAL = {
    fontFamily: 'AudiType, sans-serif',
    letterSpacing: '0px',
    fontWeight: '400',
    textDecoration: 'underline',
    fontSize: '10px',
    lineHeight: '16px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LINK_ORDER4_BOLD = {
    fontFamily: 'AudiType, sans-serif',
    letterSpacing: '0px',
    fontWeight: '700',
    textDecoration: 'underline',
    fontSize: '10px',
    lineHeight: '16px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LINK_ORDER4_SHORT = {
    fontFamily: 'AudiType, sans-serif',
    letterSpacing: '0px',
    fontWeight: '400',
    textDecoration: 'underline',
    fontSize: '10px',
    lineHeight: '12px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LINK_ORDER4_SHORT_BOLD = {
    fontFamily: 'AudiType, sans-serif',
    letterSpacing: '0px',
    fontWeight: '700',
    textDecoration: 'underline',
    fontSize: '10px',
    lineHeight: '12px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LABEL_ORDER1_NORMAL = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LABEL_ORDER1_BOLD = {
    ...common,
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LABEL_ORDER2_NORMAL = {
    ...common,
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LABEL_ORDER2_BOLD = {
    ...common,
    fontWeight: '700',
    fontSize: '14px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LABEL_ORDER3_NORMAL = {
    ...common,
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '16px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LABEL_ORDER3_BOLD = {
    ...common,
    fontWeight: '700',
    fontSize: '12px',
    lineHeight: '16px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LABEL_ORDER4_NORMAL = {
    ...common,
    fontWeight: '400',
    fontSize: '10px',
    lineHeight: '12px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LABEL_ORDER4_BOLD = {
    ...common,
    fontWeight: '700',
    fontSize: '10px',
    lineHeight: '12px',
    fontStretch: '105%'
};
export const SEM_TYPOGRAPHY_ACTION_XS_LABEL = {
    ...common,
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '16px',
    fontStretch: '105%'
};
export const SEM_TYPOGRAPHY_ACTION_SM_LABEL = {
    ...common,
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SEM_TYPOGRAPHY_ACTION_MD_LABEL = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SEM_TYPOGRAPHY_ACTION_MD_SUBLINE = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SEM_TYPOGRAPHY_ACTION_LG_LABEL = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SEM_TYPOGRAPHY_FEEDBACK_LABEL = {
    ...common,
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SEM_TYPOGRAPHY_FEEDBACK_VALUE = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SEM_TYPOGRAPHY_FEEDBACK_HEADLINE = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '130%'
};
export const SEM_TYPOGRAPHY_FEEDBACK_COPY = {
    ...common,
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '24px',
    fontStretch: '105%'
};
export const SEM_TYPOGRAPHY_FEEDBACK_RANGE = {
    ...common,
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SEM_TYPOGRAPHY_FEEDBACK_BADGE_INFO = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SEM_TYPOGRAPHY_FORMS_LABEL = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SEM_TYPOGRAPHY_FORMS_LABEL_SMALL = {
    ...common,
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SEM_TYPOGRAPHY_FORMS_INPUT = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SEM_TYPOGRAPHY_FORMS_APPENDIX = {
    ...common,
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '16px',
    fontStretch: '105%'
};
export const SEM_TYPOGRAPHY_FORMS_EXTENSION = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SEM_TYPOGRAPHY_FORMS_CAPTION = {
    ...common,
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '16px',
    fontStretch: '105%'
};
export const SEM_TYPOGRAPHY_FORMS_RANGE = {
    ...common,
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SEM_TYPOGRAPHY_UI_CAPTION = {
    ...common,
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '16px',
    fontStretch: '105%'
};
export const SEM_TYPOGRAPHY_UI_MD_LABEL = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SEM_TYPOGRAPHY_UI_MD_HEADLINE = {
    ...common,
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '105%'
};
export const SEM_TYPOGRAPHY_UI_MD_COPY = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '105%'
};
export const SEM_TYPOGRAPHY_UI_MD_CAPTION = {
    ...common,
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '16px',
    fontStretch: '105%'
};
export const SEM_TYPOGRAPHY_UI_SM_LABEL = {
    ...common,
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SEM_TYPOGRAPHY_UI_XS_LABEL = {
    ...common,
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '16px',
    fontStretch: '105%'
};
export const SEM_TYPOGRAPHY_NAVIGATION_SM_LABEL_NORMAL = {
    ...common,
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SEM_TYPOGRAPHY_NAVIGATION_SM_LABEL_BOLD = {
    ...common,
    fontWeight: '700',
    fontSize: '14px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SEM_TYPOGRAPHY_NAVIGATION_MD_LABEL_NORMAL = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SEM_TYPOGRAPHY_NAVIGATION_MD_LABEL_BOLD = {
    ...common,
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const CMP_TYPOGRAPHY_FEEDBACK_PROGRESS_INDICATOR_LG_LABEL = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const CMP_TYPOGRAPHY_FEEDBACK_PROGRESS_INDICATOR_LG_VALUE = {
    ...common,
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const CMP_TYPOGRAPHY_FEEDBACK_PROGRESS_INDICATOR_MD_LABEL = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const CMP_TYPOGRAPHY_FEEDBACK_PROGRESS_INDICATOR_MD_VALUE = {
    ...common,
    fontWeight: '400',
    fontSize: '10px',
    lineHeight: '12px',
    fontStretch: '105%'
};
export const CMP_TYPOGRAPHY_FEEDBACK_PROGRESS_INDICATOR_MD_RANGE = {
    ...common,
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const CMP_TYPOGRAPHY_FEEDBACK_PROGRESS_INDICATOR_SM_LABEL = {
    ...common,
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const CMP_TYPOGRAPHY_UI_AVATAR_2_XS_LABEL = {
    ...common,
    fontWeight: '400',
    fontSize: '10px',
    lineHeight: '12px',
    fontStretch: '105%'
};
export const CMP_TYPOGRAPHY_UI_AVATAR_XS_LABEL = {
    ...common,
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '16px',
    fontStretch: '105%'
};
export const CMP_TYPOGRAPHY_UI_AVATAR_SM_LABEL = {
    ...common,
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const CMP_TYPOGRAPHY_UI_AVATAR_MD_LABEL = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const CMP_TYPOGRAPHY_UI_PRODUCT_TILE_HEADLINE = {
    ...common,
    fontWeight: '700',
    fontSize: '20px',
    lineHeight: '32px',
    fontStretch: '130%'
};
export const CMP_TYPOGRAPHY_UI_PRODUCT_TILE_PRICE_PRIMARY = {
    ...common,
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '105%'
};
export const CMP_TYPOGRAPHY_UI_PRODUCT_TILE_PRICE_SECONDARY = {
    ...common,
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '24px',
    fontStretch: '105%'
};
export const CMP_TYPOGRAPHY_UI_TABLE_TITLE = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '130%'
};
export const CMP_TYPOGRAPHY_UI_TEXT_LIST_MD_LABEL = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '105%'
};
export const CMP_TYPOGRAPHY_UI_TEXT_LIST_MD_COPY = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '105%'
};
export const CMP_TYPOGRAPHY_UI_TEXT_LIST_SM_LABEL = {
    ...common,
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '24px',
    fontStretch: '105%'
};
export const CMP_TYPOGRAPHY_UI_TEXT_LIST_SM_COPY = {
    ...common,
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '24px',
    fontStretch: '105%'
};
export const CMP_TYPOGRAPHY_UI_TEXT_LIST_XS_LABEL = {
    ...common,
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const CMP_TYPOGRAPHY_UI_TEXT_LIST_XS_COPY = {
    ...common,
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const CMP_TYPOGRAPHY_UI_VALUE_XS_LABEL = {
    ...common,
    fontWeight: '400',
    fontSize: '24px',
    lineHeight: '36px',
    fontStretch: '130%'
};
export const CMP_TYPOGRAPHY_UI_VALUE_XS_HEADLINE = {
    ...common,
    fontWeight: '400',
    fontSize: '24px',
    lineHeight: '36px',
    fontStretch: '130%'
};
export const CMP_TYPOGRAPHY_UI_VALUE_XS_CAPTION = {
    ...common,
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const CMP_TYPOGRAPHY_UI_VALUE_SM_LABEL = {
    ...common,
    fontWeight: '400',
    fontSize: '32px',
    lineHeight: '48px',
    fontStretch: '130%'
};
export const CMP_TYPOGRAPHY_UI_VALUE_SM_HEADLINE = {
    ...common,
    fontWeight: '400',
    fontSize: '32px',
    lineHeight: '48px',
    fontStretch: '130%'
};
export const CMP_TYPOGRAPHY_UI_VALUE_SM_CAPTION = {
    ...common,
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '24px',
    fontStretch: '105%'
};
export const CMP_TYPOGRAPHY_UI_VALUE_MD_LABEL = {
    ...common,
    fontWeight: '400',
    fontSize: '44px',
    lineHeight: '64px',
    fontStretch: '130%'
};
export const CMP_TYPOGRAPHY_UI_VALUE_MD_HEADLINE = {
    ...common,
    fontWeight: '400',
    fontSize: '44px',
    lineHeight: '64px',
    fontStretch: '130%'
};
export const CMP_TYPOGRAPHY_UI_VALUE_MD_CAPTION = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '105%'
};
export const CMP_TYPOGRAPHY_UI_VALUE_LG_LABEL = {
    ...common,
    fontWeight: '400',
    fontSize: '52px',
    lineHeight: '76px',
    fontStretch: '130%'
};
export const CMP_TYPOGRAPHY_UI_VALUE_LG_HEADLINE = {
    ...common,
    fontWeight: '400',
    fontSize: '52px',
    lineHeight: '76px',
    fontStretch: '130%'
};
export const CMP_TYPOGRAPHY_UI_VALUE_LG_CAPTION = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '105%'
};
//# sourceMappingURL=typography.generated.js.map